import React, {Component, Fragment} from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from "@mui/material/IconButton";

class OrganizationMenu extends Component {

    render() {
        const {openModal} = this.props;

        return(
            <Fragment>
                <IconButton
                    aria-label="More"
                    aria-haspopup="true"
                    onClick={(e) => openModal(e)}
                    sx={{padding:"5px"}}
                >
                    <SettingsIcon sx={{fontSize: '22px', color: '#003300'}} />
                </IconButton>
            </Fragment>
        )
    }
}


export {OrganizationMenu}

